import React, { lazy } from "react";
import Browser from "../browser";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { BottomTabsWrapper } from "./BottomTabs";
import EstadaSuspense from "./EstadaSuspense";
import NavigationSidebar from "./NavigationTree2/NavigationSidebar";
import PanelResizer from "./PanelResizer";
import Toolbar from "./Toolbar";
import WorkingPanes from "./WorkingPanes";

const ConnectionDashboardView = lazy(() => import("./connectionDashboard/ConnectionDashboard"));

/** Switches the main workspace without changing the user's open panes or active tab. */
export default function AppWorkspace() {
  useOnChangeWatcher(state.connectionDashboardMode);
  const connectionDashboard = state.connectionDashboardMode.value;
  const landscape = Browser.isLandScape();
  return (
    <>
      {!connectionDashboard && !landscape && <Toolbar />}
      <div style={{ position: "relative", display: "flex", flexDirection: "row", width: "100%",
        minHeight: 0, overflow: "hidden", backgroundColor: "var(--colorTransparent)", flex: "1 1 0" }}>
        {connectionDashboard ? (
          <EstadaSuspense Component={ConnectionDashboardView} props={{}} />
        ) : (
          <>
            <NavigationSidebar />
            <PanelResizer leftPanelId="navigationSidebar" />
            <WorkingPanes activePanes={state.activePanes} tabItems={state.tabItems} isScreen2={false} />
            {landscape && <Toolbar />}
          </>
        )}
      </div>
      {!connectionDashboard && !landscape && (
        <div id="bottomTabHost" className="documentTabs" style={{ position: "relative", width: "100%",
          flexGrow: 0, flexShrink: 0, height: "35px", marginTop: "-10px" }}>
          <BottomTabsWrapper items={state.tabItems}
            active={state.activePanes.noPaneActiveBecauseOnlyNavigationIsVisible ? -1 : state.activePanes.activeItemIndex.value}
            onClose={(index, id) => { state.activePanes.closePane(id); }}
            onActivate={(index, id) => { state.activePanes.setActiveId(id); }}
            watchIndex={state.activePanes.activeItemIndex} moveToScreen={2} />
        </div>
      )}
    </>
  );
}
